import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ShiftService } from '../shift.service';

@Component({
  selector: 'app-shift-detail',
  templateUrl: './shift-detail.component.html',
  styleUrls: ['./shift-detail.component.scss']
})
export class ShiftDetailComponent implements OnInit {
  shiftDetail: any = [];
  pic: string;
  id: number;
  constructor(
    private route: ActivatedRoute,
    private shiftServices: ShiftService
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['Id'];
    this.getShiftDetail();
  }
  getShiftDetail() {
    this.shiftServices.getShiftbyId(this.id).subscribe(Response => {
      this.shiftDetail = Response;
    });
  }

}
